import request from '@/utils/request'

// 提交人脸识别信息
export function saveCustFace(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF005', ...data },
    loading: true
  })
}
// 提交基础信息
export function saveCustInfo(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF006', ...data },
    loading: true
  })
}

// 上送设备信息
export function submitUseDevice(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF002', ...data }
  })
}

// 账户注销
export function accountCancel() {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA010' },
    loading: true
  })
}
// 平台授信额度
export function creditQuota(data, loading = true) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BL101', ...data },
    loading
  })
}
// 卡券
export function cardPwdList(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MS008', ...data }
  })
}
// 获取卡密短信
export function smsCardPwd(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA016', ...data }
  })
}
// 获取卡密明文信息
export function pwdPlaintext(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MS009', ...data }
  })
}
// 获取积分
export function getIntegral(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF007', ...data }
  })
}
// 获取签到数据
export function getIntegralSign(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF009', ...data }
  })
}
// 获取积分
export function listIntegralDetail(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF008', ...data }
  })
}
// 获取签到数据
export function submitSign(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF010', ...data },
    loading: true
  })
}
// 提交通讯录讯息
export function saveContacts(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF011', ...data }
  })
}
// 获取产品额度
export function getProductQuota(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF012', ...data }
  })
}
// 获取回收地址
export function getRecoveryUrl(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'EC001', ...data },
    loading: true
  })
}
// 获取回收地址
export function getsxRecoveryUrl(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MS015', ...data },
    loading: true
  })
}
export function updateCustomerCreditInfo(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF015', ...data },
    loading: true
  })
}
// 渠道授信信息
export function chnlCreditInfo(data, loading = true) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BL102', ...data },
    loading
  })
}

// 查询泉易通会员开通状态
export function queryQytVipStatus(data, loading = true) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'EM001', ...data },
    loading
  })
}
